import { ThemeBlueprint } from '@backstage/plugin-app-react';
import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';
import {
  createBaseThemeOptions,
  createUnifiedTheme,
  palettes,
  UnifiedThemeProvider,
} from '@backstage/theme';

const solidBluePageTheme = {
  colors: ['#002169'],
  shape: 'none',
  backgroundImage: 'linear-gradient(90deg, #002169, #002169)',
  fontColor: '#FFFFFF',
};

const obosTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    fontFamily: 'system-ui',
    palette: {
      ...palettes.light,
      navigation: {
        background: '#002169', // OBOS blue color
        indicator: '#0f62fe',
        color: '#fff',
        selectedColor: '#fff',
        submenu: {
          background: '#002169',
        },
      },
    },
  }),
  pageTheme: {
    home: solidBluePageTheme,
  },
});

export const obosThemeExtension: ExtensionDefinition = ThemeBlueprint.make({
  name: 'obos-theme',
  params: {
    theme: {
      id: 'obos-theme',
      title: 'OBOS Theme',
      variant: 'light',
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={obosTheme} children={children} />
      ),
    },
  },
});
